import { CreateNode } from "@react-admin/ra-tree";
import { SimpleForm } from "react-admin";
import { settings } from "app/settings";

const TreeNodeCreate = ({ name }) => {
  const FormComponent = settings.getUrlTreeComponent(name);

  return (
    <CreateNode
      mutationMode="pessimistic"
      title="Създай нов елемент"
      mutationOptions={{ meta: { useFormData: false } }}
    >
      <SimpleForm>
        <FormComponent />
      </SimpleForm>
    </CreateNode>
  );
};

export default TreeNodeCreate;
